import React, { useEffect } from 'react';

// material
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';

// import everything from firebase
import {
  signInWithPopup,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { auth, googleProvider } from '../../config/firebaseConfig';

export default function FormDialog({ open, handleClose, setOpen }) {
  // state for email and password
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  // firebase signUp
  const signUp = async () => {
    setLoading(true);
    try {
      await createUserWithEmailAndPassword(auth, email, password);
    } catch (error) {
      alert(error.message);
    }
    setLoading(false);
  };

  // firebase login
  const login = async () => {
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      alert(error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setOpen(false);
      }
    });
  }, [setOpen]);

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Signup || Login</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="admin@gmail.com"
            type="email"
            fullWidth
            variant="standard"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            margin="dense"
            id="password"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            style={{ marginRight: '20px' }}
            type="submit"
            disabled={loading}
            onClick={() => signUp()}
          >
            Signup
          </Button>
          <Button
            disabled={loading}
            variant="contained"
            style={{ marginRight: '20px' }}
            type="submit"
            onClick={() => login()}
          >
            Login
          </Button>
        </DialogActions>

        <div style={{ textAlign: 'center', margin: '10px 0' }}>OR</div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
          }}
        >
          <div
            className="authBtn"
            onClick={() => signInWithPopup(auth, googleProvider)}
          >
            <GoogleIcon />
          </div>
          <div className="authBtn">
            <FacebookIcon />
          </div>
        </div>
      </Dialog>
    </>
  );
}
